(function() {
    angular.module('tmx-app').controller('HouseholdMembersController', ['$mdDialog','$scope','HouseholdMembers','lookupService','showAddButton','guarantorTabEditPrivilege', 'ToastService', 
  
        function HouseholdMembersController($mdDialog,$scope,HouseholdMembers,lookupService,showAddButton,guarantorTabEditPrivilege,ToastService) {
            $scope.vm = {};
            $scope.vm.HouseHoldMembersData = HouseholdMembers;
            $scope.vm.lookup = {};
            $scope.vm.lookup.yesno = lookupService.getLocalLookupsByType('YES_NO');
            $scope.vm.lookup.relationList = lookupService.getLocalLookupsByType('Relatives_list');

            $scope.showOk = true;
            $scope.showAdd = showAddButton;
            $scope.guarantorTabEditPrivilege = guarantorTabEditPrivilege;
  
  
            $scope.ok = function(form) {
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide();
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
            };
            $scope.add = function(form) {
  
                form.$submitted=true;
                if(form.$valid){
                    $mdDialog.hide($scope.vm.HouseHoldMembersData);
                }
                else {
                    ToastService.showCustomToast("error","Form Invalid.");
                }
  
            };
  
  
            $scope.cancel = function() {
                $mdDialog.hide();
            };
  
  
        }]);
})();